
import { forwardRef } from 'react';

const Contact = forwardRef<HTMLElement>((props, ref) => {
  return (
    <section
      ref={ref}
      className="py-12 px-[4%] opacity-0 transition-all duration-1000 bg-gradient-to-b from-[#1A365D] to-[#0F1F3D] relative overflow-hidden"
    >
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Sparkle stars */}
        <div
          className="absolute top-8 left-[15%] w-2 h-2 star-4 animate-twinkle"
          style={{ backgroundColor: 'rgba(214, 184, 146, 0.25)', filter: 'drop-shadow(0 0 3px rgba(214, 184, 146, 0.3))', animationDelay: '0s' }}
        />
        <div
          className="absolute top-12 right-[18%] w-2.5 h-2.5 star-4 animate-twinkle"
          style={{ backgroundColor: 'rgba(212, 175, 55, 0.3)', filter: 'drop-shadow(0 0 4px rgba(212, 175, 55, 0.3))', animationDelay: '0.6s' }}
        />
        <div
          className="absolute top-20 left-[25%] w-1.5 h-1.5 star-4 animate-twinkle"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', filter: 'drop-shadow(0 0 2px rgba(255, 255, 255, 0.25))', animationDelay: '1.2s' }}
        />
        <div
          className="absolute top-16 right-[30%] w-2 h-2 star-4 animate-twinkle"
          style={{ backgroundColor: 'rgba(214, 184, 146, 0.2)', filter: 'drop-shadow(0 0 3px rgba(214, 184, 146, 0.25))', animationDelay: '1.8s' }}
        />

        {/* Brand signature */}
        <div className="mb-10 text-center">
          <h2
            className="mb-1"
            style={{
              fontFamily: "'Alex Brush', cursive",
              fontSize: 'clamp(3.5rem, 12vw, 6rem)',
              color: '#d6b892',
              letterSpacing: '0.02em',
              lineHeight: 0.9
            }}
          >
            Mavi
          </h2>
          <h3
            className="mb-4"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
              color: 'rgba(214, 184, 146, 0.75)',
              fontWeight: 400,
              letterSpacing: '0.4em',
              textTransform: 'uppercase'
            }}
          >
            Patısserıe
          </h3>
          <div className="w-12 h-px bg-[rgba(212,175,55,0.5)] mx-auto mb-4"></div>
          <p className="text-[#B8C5D6] text-sm tracking-[0.15em]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
            El Yapımı Lezzetler, Unutulmaz Anlar
          </p>
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* Address */}
          <div className="text-center">
            <h4 className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-3 font-semibold">
              Adres
            </h4>
            <p className="text-[#B8C5D6] text-sm leading-relaxed">
              Karlıbayır Mahallesi<br />
              Karlıbayır Caddesi No: 14<br />
              Arnavutköy, İstanbul
            </p>
          </div>

          {/* Contact */}
          <div className="text-center">
            <h4 className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-3 font-semibold">
              İletişim
            </h4>
            <div className="space-y-2">
              <a
                href="tel:+905410000000"
                className="block text-white text-base hover:text-[#D4AF37] transition-colors cursor-pointer"
              >
                +90 (541) 000 00 00
              </a>
              <a
                href="mailto:info@mavipastane.com"
                className="block text-white text-base hover:text-[#D4AF37] transition-colors cursor-pointer"
              >
                info@mavipastane.com
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="text-center">
            <h4 className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-3 font-semibold">
              Takip Edin
            </h4>
            <div className="flex gap-3 justify-center">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-[#D4AF37] rounded-full text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A365D] transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-[#D4AF37] rounded-full text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A365D] transition-all cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://whatsapp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-[#D4AF37] rounded-full text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A365D] transition-all cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="pt-6 border-t border-[#D4AF37]/20">
          <div className="text-center text-[#B8C5D6] text-xs">
            <p>© 2026 Mavi Patisserie. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </div>
    </section>
  );
});

Contact.displayName = 'Contact';

export default Contact;
